<template>
  <MainTemplate withoutContainer>
    <section class="top_section">
      <video autoplay preload="auto" muted playsinline>
        <source src="../../assets/video/home_top_5.mp4" type="video/mp4">
      </video>
    </section>
    <section class="about text" v-if="isDescShow" style="padding-top: 50px!important;font-size: 19px;text-align: justify;">
      <container>
        <p v-for="desc in descriprion" :key="'desc'+desc.id" v-html="desc.text"></p>
      </container>
    </section>
    <section class="features" v-if="advantages.master.length > 0">
      <container>
        <div class="section__title">Мастеру</div>
        <div class="features__flex">
          <div class="features__flex-item"
               v-for="adv in advantages.master"
               :key="adv.id"
          >
            <div class="image" :style="{backgroundColor: adv.color}">
              <img :src="adv.icon" alt="">
            </div>
            <div class="title">{{ adv.title }}</div>
            <p class="desc">{{ adv.description }}</p>
          </div>
        </div>
      </container>
    </section>

    <section class="about home_page_about_section" v-if="features.length > 0">
      <container>
        <div class="about__wrap">
          <div class="about__wrap-item"
               v-for="feature in features"
               :key="feature.id"
          >
            <div class="images">
              <carousel
                  :slides-to-show="1"
                  :infinite="false"
              >
                <div class="images__item"
                     v-for="(img, idx) in feature.images"
                     :key="idx"
                >
                  <img :src="img.path" alt="">
                </div>
              </carousel>
            </div>
            <div class="text">
              <div class="title">{{ feature.title }}</div>
              <p class="desc"  style="text-align: justify" v-html="feature.description"></p>
            </div>
          </div>
        </div>
      </container>
    </section>

    <section class="features white" v-if="advantages.client.length > 0">
      <container>
        <div class="section__title">клиенту</div>
        <div class="features__flex">
          <div class="features__flex-item"
               v-for="adv in advantages.client"
               :key="adv.id"
          >
            <div class="image" :style="{backgroundColor: adv.color}">
              <img :src="adv.icon" alt="">
            </div>
            <div class="title">{{ adv.title }}</div>
            <p class="desc">{{ adv.description }}</p>
          </div>
        </div>
      </container>
    </section>

    <section class="works home_page_works_section" v-if="works.length > 0">
      <container>
        <div class="section__title">работы мастеров</div>
        <div class="works__carousel">
          <carousel
              @before-change="beforeChangeSlider"
              ref="carousel"
              :slides-to-show="3"
              :infinite="false"
              :navButtons="false"
              :dots="false"
              :responsive="responsive"
          >
            <div class="works__item"
                 @click="workItemClick(w.id)"
                 v-for="(w, idx) in works"
                 :key="idx"
            >
              <div class="image">
                <img :src="w.path" alt="" height="100%" style="object-fit: cover">
                <div class="name">{{ w.fullName }}</div>
                <div class="view">
                  <img src="@/assets/images/icons/search.svg">
                  <span>
                    Нажмите для увеличения
                  </span>
                </div>
              </div>
              <ButtonComponent
                  variant="filled"
                  width="100%"
                  v-if="$store.getters.isUserAuth && $store.getters.isClient"
                  @click="createConversation(w.master_id)"
              >
                Написать мастеру
              </ButtonComponent>
            </div>
          </carousel>
          <CoolLightBox
              :items="workItems"
              :index="selectedWorkIndex"
              @close="selectedWorkIndex = null">
          </CoolLightBox>
          <div class="works_slider__btn prev" v-if="isVisiblePrev">
            <button @click="goToPrevSlide"></button>
          </div>
          <div class="works_slider__btn next" v-if="isVisibleNext">
            <button @click="goToNextSlide"></button>
          </div>
        </div>
      </container>
    </section>
  </MainTemplate>
</template>

<script>
import MainTemplate from '@/templates/MainTemplate'
import Container from '@/components/grid/Container'
import {VueAgile} from 'vue-agile'
import ButtonComponent from '@/components/ui/buttons/button-component'
import {mapGetters, mapMutations} from "vuex"
import ChatMixin from "@/mixins/chat"

export default {
  name: 'Home',
  components: {ButtonComponent, Container, MainTemplate, carousel: VueAgile},
  mixins: [
    ChatMixin
  ],
  data: () => ({
    advantages: {
      client: [],
      master: []
    },
    features: [],
    works: [],
    isVisiblePrev: false,
    isVisibleNext: true,
    vhide: true,
    descriprion: [],
    responsive: [
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 3
        }
      }
    ],
    selectedWorkIndex: null
  }),
  mounted() {
    this.loadFeatures()
        .loadAdvantages('client')
        .loadAdvantages('master')
        .loadPortfolio()
        .loadDescription()
        .openRegisterModal()
        .openLoginModal();
  },
  computed: {
    ...mapGetters(['getUser']),
    workItems() {
      return this.works.map(work => work.path)
    },
    isDescShow() {
      if (this.descriprion.length != 0) {
        return this.descriprion.some(item => item.status == '1')
      } else return false
    }
  },
  methods: {
    ...mapMutations(['openModal', 'setModalData']),
    openLoginModal() {
      if (this.$route.params.permission && !this.getUser) this.openModal('login');
      return this;
    },
    openRegisterModal() {
      if (!this.$route.params.code || this.getUser) return this;
      this.openModal('register_main');
      return this;
    },
    loadAdvantages(type) {
      this.$api.home.advantage.list(type).then(({data}) => this.advantages[type] = data)
      return this
    },
    loadFeatures() {
      this.$api.home.feature.list().then(({data}) => this.features = data)
      return this
    },
    loadDescription() {
      this.$api.home.description.list().then(({data}) => this.descriprion = data)
      return this
    },
    loadPortfolio() {
      this.$api.home.portfolio.list().then(({data}) => {
        this.works = data
      })
      return this
    },
    goToNextSlide() {
      this.$refs.carousel.goToNext()
    },
    goToPrevSlide() {
      this.$refs.carousel.goToPrev()
    },
    beforeChangeSlider(e) {
      // Проверка на видимость кнопок
      this.isVisiblePrev = e.nextSlide > 0
      this.isVisibleNext = e.nextSlide + 3 < this.works.length
      // Проверка на переход до след. слайда
      if (e.nextSlide <= 0) {
        this.$refs.carousel.goTo(0)
      }

      // breakpoint
      let breakpoint = 3
      const documentWidth = document.documentElement.clientWidth

      if (documentWidth < 1170 && documentWidth > 900) {
        breakpoint = 2
      } else if (documentWidth < 900 && documentWidth > 600) {
        breakpoint = 1
      } else if (documentWidth < 600) {
        breakpoint = 1
      }

      if (e.nextSlide + breakpoint > this.works.length) {
        this.$refs.carousel.goTo(this.works.length - breakpoint)
      }
    },
    workItemClick(id) {
      this.works.forEach(work => {
        if (work.id === id) {
          this.selectedWorkIndex = this.workItems.findIndex(item => item === work.path)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.top_section {
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background-color: #f0e1d6;

  video {
    object-fit: cover;
    min-height: 100%;
    width: 100%;
  }

  @media(max-width: 800px) {
    video {
      object-fit: cover;
      min-height: 100vw;
      min-width: 100%;
    }
  }
}

.section__title {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 56px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #383838;
  text-align: center;
  margin-bottom: 100px;
}

.features {
  background-color: #FDF8F4;
  padding-top: 150px;

  &.white {
    padding-bottom: 150px;
    background-color: #fff;
  }

  &__flex {
    padding: 0 80px;
    display: flex;
    justify-content: space-between;

    &-item {
      max-width: 330px;
      text-align: center;

      .image {
        margin: 0 auto;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        background-color: #F28C8C;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

      }

      .title {
        font-family: "Montserrat", sans-serif;
        margin-top: 30px;
        margin-bottom: 20px;
        font-weight: 600;
        font-size: 32px;
        line-height: 1.3;
        color: #383838;
      }

      .desc {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 1.4;
        color: #383838;
      }
    }
  }
}

.about {
  padding-top: 50px;
  background-color: #FDF8F4;
  padding-bottom: 50px;

  &__wrap {
    &-item {
      display: flex;
      justify-content: center;
      margin-bottom: 100px;

      .images {
        width: 100%;
        max-width: 700px;

        &__item {
          overflow: hidden;
        }

        img {
          max-width: 100%;
        }
      }

      .title {
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
        font-size: 32px;
        line-height: 1.25;
        color: #383838;
        margin-bottom: 20px;
      }

      .desc {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 1.4;
        color: #383838;
      }

      .text {
        display: flex;
        justify-content: center;
        flex-direction: column;
        max-width: 600px;
        margin-left: 140px;
      }

      &:nth-child(even) {
        flex-direction: row-reverse;

        .text {
          margin-left: 0;
          margin-right: 140px;
        }
      }
    }
  }
}

.works {
  padding-top: 150px;
  padding-bottom: 200px;

  &__carousel {
    position: relative;
  }

  &__item {
    padding: 0 15px;
    max-width: 480px;
    width: auto !important;

    .image {
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 300px;
      margin-bottom: 10px;
      border-radius: 10px;
      cursor: pointer;

      .name {
        padding: 8px 15px 8px 10px;
        border-radius: 0px 10px 10px 0px;
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 10px;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        line-height: 1.5;
        color: #383838;
        font-weight: 600;
      }

      .view {
        padding: 8px 10px;
        height: 40px;
        border-radius: 10px 0px 0px 10px;
        background-color: #fff;
        position: absolute;
        right: 0;
        top: 10px;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        line-height: 1.5;
        color: #383838;
        font-weight: 600;
        display: flex;
        max-width: 40px;
        align-items: center;
        transition: opacity .3s, max-width .4s;

        span {
          transition: all .3s;
          min-width: 240px;
          margin-left: 10px;
          opacity: 0;
        }
      }

      &:hover .view {
        max-width: 270px;

        span {
          position: relative;
          opacity: 1;
        }
      }
    }
  }

  .works_slider__btn {
    position: absolute;
    bottom: 0;
    top: 0;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.prev {
      background: linear-gradient(90deg, rgba(253, 248, 244, 1), rgba(253, 248, 244, 0));
      left: 0;

      button {
        background-image: url('../../assets/images/icons/chevron-left.svg');
      }
    }

    &.next {
      background: linear-gradient(270deg, #FDF8F4 0%, rgba(253, 248, 244, 0) 100%);
      right: 0;

      button {
        background-image: url('../../assets/images/icons/chevron-right.svg');
      }
    }

    button {
      background-color: #FFFFFF;
      background-position: center center;
      background-repeat: no-repeat;
      border: 1px solid #B9765B;
      box-sizing: border-box;
      border-radius: 5px;
      width: 40px;
      height: 40px;
    }
  }
}

@media screen and (max-width: 1170px) {
  .features__flex-item {
    .title {
      font-size: 26px;
    }

    .desc {
      font-size: 16px;
    }
  }

  .about__wrap-item .images {
    max-width: 600px;
  }
}

@media screen and (max-width: 991px) {
  .features {
    padding: 80px 0;

    &__flex {
      flex-direction: column;
      align-items: center;

      &-item {
        margin-bottom: 50px;

        .title {
          margin-top: 20px;
          font-size: 24px;
          line-height: 1.3;
        }

        .desc {
          font-size: 16px;
        }
      }
    }
  }

  .section__title {
    font-size: 24px;
    line-height: 1.3;
    margin-bottom: 50px;
  }

  .about {
    padding-bottom: 30px;

    &__wrap-item {
      align-items: center;
      flex-direction: column;
      margin-bottom: 50px;

      &:nth-child(even) {
        flex-direction: column;

        .text {
          margin-right: 0;
        }
      }

      .text {
        margin-left: 0;
      }

      .images {
        max-width: 600px;
        margin-bottom: 20px;
      }

      .title {
        font-size: 24px;
      }

      .desc {
        font-size: 16px;
      }
    }
  }

  .works {
    .works_slider__btn {
      display: none;
    }

    &__item .image {
      height: 225px;
    }
  }
}
</style>

<style lang="scss">
.home_page_about_section {
  .agile__nav-button {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    width: 40px;
    height: 40px;
    font-size: 0;
    background-color: #FFFFFF;
    border: 1px solid #B9765B;
    border-radius: 5px;
    background-position: center center;
    background-repeat: no-repeat;

    &:disabled {
      opacity: .6;
    }

    &--prev {
      left: 20px;
      background-image: url('../../assets/images/icons/chevron-left.svg');
    }

    &--next {
      right: 20px;
      background-image: url('../../assets/images/icons/chevron-right.svg');
    }
  }

  .agile__dots {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;

    .agile__dot {
      button {
        background-color: #FFFFFF;
        border-radius: 5px;
        width: 10px;
        height: 10px;
        border: none;
        margin: 0 10px;
      }

      &--current button {
        margin: 0 8px;
        width: 12px;
        height: 12px;
        border: 2px solid #B9765B;
      }
    }
  }
}
</style>
